import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types/api';
import { ILeagueDailyCoverageApiListResponse } from '@/types/leagueDailyCoverage';

export const leagueDailyCoverageList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ILeagueDailyCoverageApiListResponse>> => {
    return axios.get('/api/leagueDailyCoverage/list', { ...config, params });
};

export const leagueDailyCoverageExport = (params: IApiListParams): Promise<AxiosResponse<Blob>> => {
    return axios.get('/api/leagueDailyCoverage/export', { params, responseType: 'blob' });
};
